import { TabContext, TabList } from "@mui/lab";
import { Box, Tab as MuiTab, styled } from "@mui/material";

import { background, button, text } from "@/modules/irohana-components/theme/colors-new";
import { rounded } from "@/modules/irohana-components/theme/variables";
import { FCC } from "@/modules/irohana-components/types/common";

export type TTabProps = {
  value: string | number;
  onChange?: ((event: React.SyntheticEvent, value: string | number) => void) | undefined;
  options: { label: string; value: string | number }[];
  selected?: string | number;
  bgColor?: string;
  tabGap?: string | number;
  borderBottomColor?: string;
  tabFontSize?: string | number;
  tabHeight?: string | number;
  activeTabColor?: string;
  inactiveTabColor?: string;
};

export const Tab: FCC<TTabProps> = ({
  value,
  onChange,
  options,
  children,
  selected,
  bgColor = background.base,
  tabGap = "8px",
  borderBottomColor = button.primary,
  tabFontSize = "16px",
  tabHeight = "fit-content",
  activeTabColor = button.primary,
  inactiveTabColor = text.disable,
}) => {
  return (
    <BoxTabWrapper
      bgColor={bgColor}
      tabGap={tabGap}
      borderBottomColor={borderBottomColor}
      tabFontSize={tabFontSize}
      tabHeight={tabHeight}
      inactiveTabColor={inactiveTabColor}
      activeTabColor={activeTabColor}
    >
      <TabContext value={value}>
        <TabList onChange={onChange} variant="fullWidth">
          {options.map((opt, index) => (
            <TabWrapper
              sx={{
                backgroundColor: selected === opt.value ? `${activeTabColor} !important` : inactiveTabColor,
              }}
              key={index}
              label={opt.label}
              value={opt.value}
            />
          ))}
        </TabList>
        {children}
      </TabContext>
    </BoxTabWrapper>
  );
};

const BoxTabWrapper = styled(Box)<{
  bgColor: string;
  tabGap: string | number;
  borderBottomColor: string;
  tabFontSize: string | number;
  tabHeight: string | number;
  inactiveTabColor: string;
  activeTabColor: string;
}>`
  background-color: ${({ bgColor }) => bgColor};
  & .MuiTabs-indicator {
    display: none;
  }

  & .MuiTabs-root {
    min-height: unset;
  }

  & .MuiTabs-flexContainer {
    justify-content: space-between;
    gap: ${({ tabGap }) => (typeof tabGap === "number" ? `${tabGap}px` : tabGap)};
    border-bottom: 4px solid ${({ borderBottomColor }) => borderBottomColor};

    & .MuiButtonBase-root {
      text-transform: none;
      font-weight: bold;
      font-size: ${({ tabFontSize }) => (typeof tabFontSize === "number" ? `${tabFontSize}px` : tabFontSize)};
      min-height: unset;
      height: ${({ tabHeight }) => (typeof tabHeight === "number" ? `${tabHeight}px` : tabHeight)};
      padding: 8px 16px;
      color: ${text.white};
      background-color: ${({ inactiveTabColor }) => inactiveTabColor};
      border-top-right-radius: ${rounded.sm};
      border-top-left-radius: ${rounded.sm};
    }

    & .Mui-selected {
      background-color: ${({ activeTabColor }) => activeTabColor};
    }
  }
`;

const TabWrapper = styled(MuiTab)``;
